var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M13.362 17c-.262 0-.523-.102-.719-.305l-3.863-4c-.378-.393-.373-1.016.013-1.402l4-4c.39-.39 1.023-.39 1.414 0 .39.391.39 1.023 0 1.414l-3.305 3.305 3.18 3.293c.383.398.372 1.031-.025 1.414-.195.188-.445.281-.695.281",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-left.c8778eab.svg";
export { ForwardRef as ReactComponent };